import React from 'react'

const DepositsPage = () => {
  return (
    <div>DepositsPage</div>
  )
}

export default DepositsPage;